'use strict';

angular.module('atex.dam').factory('DamTaskService', ['$q', 'ContentService', 'DamNotificationService', '$translate',
  function ($q, ContentService, DamNotificationService, $translate) {
    var _getTask = function (id) {
      var deferred = $q.defer();

      var transferInfo = {
        id: atex.dam.AngularUtils.removePrefix(id)
      };

      ContentService.getContent(transferInfo).then(function (task) {
        deferred.resolve(task);
        task._data = task.data;
      }).then(null, function (error) {
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        deferred.reject(error);
      });

      return deferred.promise;
    };

    return {
      tasks: function (tasks) {
        var deferred = $q.defer();

        var promises = tasks.map(function (task) {
          return _getTask(task);
        });

        $q.all(promises).then(function (objects) {
          deferred.resolve(objects);
        });

        return deferred.promise;
      }
    };
  }
]);
